import React, { useState } from "react";
import Head from "../../layout/head/Head";
import { Card, FormGroup, Spinner } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  InputSwitch,
  Button,
} from "../../components/Component";
import { useForm } from "react-hook-form";
import { changePassword } from "../../app/api";

import { toast, ToastContainer } from "react-toastify";

const UserProfileSettingPage = ({ sm, updateSm }) => {
  
  const { errors, handleSubmit, register, getValues, reset } = useForm();
  const [fsave, setFsave] = useState(false);
  const [passState, setPassState] = useState(false);
  const [passState2, setPassState2] = useState(false);
  const [passState3, setPassState3] = useState(false);
  const updatePass = async (data) => {
    setFsave(true)
    let uid = localStorage.getItem('uid');
    console.log(data);
    let res = await changePassword({
      user_id: uid,
      current_password: data.cur_pass,
      new_password: data.new_pass,
      confirm_password: data.rep_pass
    });

    if(res.code == 200) {
      toast.success("Password updated successfully", {
        position: "top-right",
        autoClose: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: false,
        // closeButton: <CloseButton />,
      });
      reset();
      window.location.reload();
    }
   else if(res.code == 100){
      toast.error( "Current password must be at least 4 characters", {
        position: "top-right",
        autoClose: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: false,
        // closeButton: <CloseButton />,
      }); 
    }
     else {
      toast.error( res.message, {
        position: "top-right",
        autoClose: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: false,
        // closeButton: <CloseButton />,
      }); 
    }
    setFsave(false)
  
  }

  return (
    <React.Fragment>
      <Head title="Change Password - Profile"></Head>

      <BlockHead size="lg">
        <BlockBetween>
          <BlockHeadContent>
            <BlockTitle tag="h4">Change Password</BlockTitle>
            <BlockDes>
              <p>Set a unique password to protect your account.</p>
            </BlockDes>
          </BlockHeadContent>
          <BlockHeadContent className="align-self-start d-lg-none">
            <Button
              className={`toggle btn btn-icon btn-trigger mt-n1 ${sm ? "active" : ""}`}
              onClick={() => updateSm(!sm)}
            >
              <Icon name="menu-alt-r"></Icon>
            </Button>
          </BlockHeadContent>
        </BlockBetween>
      </BlockHead>

      <Block>
        <Card className="card-bordered">
          <div className="card-inner-group">
            <div className="card-inner">
              {/* <div className="between-center flex-wrap g-3"> */}
                <div className="row">
                  <div className="col-md-6">
                  <form method="post" onSubmit={handleSubmit(updatePass)}>
                    <FormGroup>
                      <h6>Current Password</h6>
                      {/* <input type="password" className="form-control" name="cur_pass" ref={register({ required: true })} placeholder="Enter your current password" /> */}
                      <div className="form-control-wrap">
                        <a
                          href="#password"
                          onClick={(ev) => {
                            ev.preventDefault();
                            setPassState(!passState);
                          }}
                          className={`form-icon lg form-icon-right passcode-switch ${passState ? "is-hidden" : "is-shown"}`}
                          
                        >
                          <Icon name="eye" className="passcode-icon icon-show"></Icon>

                          <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                        </a>
                        <input
                          type={passState ? "text" : "password"}
                          id="cur_pass"
                          name="cur_pass"
                          defaultValue=""
                          ref={register({ required: "This field is required" })}
                          placeholder="Enter your current password"
                          className={`form-control-lg form-control ${passState ? "is-hidden" : "is-shown"}`}
                          onChange={(e) => {
                            if (/^\s*$/.test(e.target.value)) {
                              e.target.value = '';
                            }
                          }}
                        />
                        {errors.cur_pass && <span className="sm-error">Please enter your current password.</span>}
                      </div>
                    </FormGroup>
                    <FormGroup>
                      <h6>New Password</h6>
                      
                      <div className="form-control-wrap">
                        <a
                          href="#password"
                          onClick={(ev) => {
                            ev.preventDefault();
                            setPassState2(!passState2);
                          }}
                          className={`form-icon lg form-icon-right passcode-switch ${passState2 ? "is-hidden" : "is-shown"}`}
                          
                        >
                          <Icon name="eye" className="passcode-icon icon-show"></Icon>

                          <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                        </a>
                        <input
                          type={passState2 ? "text" : "password"}
                          id="new_pass"
                          name="new_pass"
                          defaultValue=""
                          ref={register({ 
                            required: 'Please enter your new password.', 
                            minLength: {
                              value: 4,
                              message: "Password minimum length should be 4 characters.",
                            },
                            // pattern: {
                            //   value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                            //   message:'Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character.'
                            // },
                            validate: {
                              notSameAsOld: (value) => value !== getValues('cur_pass') || 'Your password cannot be the same as the current password.',
                            }
                          })}
                          placeholder="Enter your new password"
                          className={`form-control-lg form-control ${passState2 ? "is-hidden" : "is-shown"}`}
                          onChange={(e) => {
                            if (/^\s*$/.test(e.target.value)) {
                              e.target.value = '';
                            }
                          }}
                        />
                        {/* {errors.new_pass?.type === 'required' && <span className="sm-error">Please enter your new password.</span>}
                        {errors.new_pass?.type === 'pattern' && <span className="sm-error">Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character </span>} */}

                        {typeof errors.new_pass !== "undefined" &&
                          (errors.new_pass.type == "required" ? (
                            <span className="sm-error">Please enter your new password.</span>
                            ) : (
                              <span className="sm-error">{errors.new_pass.message}</span>
                            )
                          )
                        }
                      </div>

                    </FormGroup>
                    <FormGroup>
                      <h6>Repeat Password</h6>
                      {/* <input type="password" className="form-control" name="rep_pass" ref={register({ required: true, validate: (val)=> val === getValues("new_pass") })}  
                      placeholder="Repeat your new password" /> */}
                      <div className="form-control-wrap">
                        <a
                          href="#password"
                          onClick={(ev) => {
                            ev.preventDefault();
                            setPassState3(!passState3);
                          }}
                          className={`form-icon lg form-icon-right passcode-switch ${passState3 ? "is-hidden" : "is-shown"}`}
                          
                        >
                          <Icon name="eye" className="passcode-icon icon-show"></Icon>

                          <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                        </a>
                        <input
                          type={passState3 ? "text" : "password"}
                          id="rep_pass"
                          name="rep_pass"
                          defaultValue=""
                          // ref={register({ required: 'Please enter your new password.', validate: (val)=> val === getValues("new_pass") })}
                          ref={register({
                            required: true,
                            validate: (val) => val === getValues("new_pass") || 'Repeat password and new password do not match.',
                          })}
                          placeholder="Repeat your new password"
                          className={`form-control-lg form-control ${passState3 ? "is-hidden" : "is-shown"}`}
                          onChange={(e) => {
                            if (/^\s*$/.test(e.target.value)) {
                              e.target.value = '';
                            }
                          }}
                        />
                        {/* {errors.rep_pass && <span className="sm-error">Repeat password must be same as new password.</span>} */}
                        {typeof errors.rep_pass !== "undefined" &&
                          (errors.rep_pass.type == "required" ? (
                            <span className="sm-error">Please re-enter your new password.</span>
                          ) : (
                            <span className="sm-error">{errors.rep_pass.message}</span>
                          ))}
                      </div>
                      
                    </FormGroup>
                    <FormGroup>
                      <Button type="submit" color="primary" disabled={fsave}>
                        {(fsave == true) ? <span><Spinner size="sm" /> &nbsp; Updating</span> : 'Update Password'}
                      </Button>
                    </FormGroup>
                  </form>
                  </div>
                </div>
                {/* <div className="nk-block-actions flex-shrink-sm-0">
                  <ul className="align-center flex-wrap flex-sm-nowrap gx-3 gy-2">
                    <li className="order-md-last">
                      <Button color="primary">Change Password</Button>
                    </li>
                    <li>
                      <em className="text-soft text-date fs-12px">
                        Last changed: <span>Oct 2, 2019</span>
                      </em>
                    </li>
                  </ul>
                </div> */}
              {/* </div> */}
            </div>
          </div>
        </Card>
      </Block>
    </React.Fragment>
  );
};
export default UserProfileSettingPage;
